import React from "react";
import {
    Box,
    Flex,
    Text,
    Link,
    Stack,
    IconButton,
    useColorModeValue,
} from "@chakra-ui/react";
import { FaFacebook, FaTwitter, FaInstagram } from "react-icons/fa";

const WebFooter = () => {
    return (
        <Box
            bg={useColorModeValue("#0d2b4a", "#0d2b4a")}
            color={useColorModeValue("white", "white")}
        >
            <Box maxW="6xl" mx="auto" py={10} px={6}>
                <Flex
                    direction={{ base: "column", md: "row" }}
                    justify="space-between"
                    align="center"
                >
                    <Text fontSize="sm" textAlign="center">
                        © {new Date().getFullYear()} AAJAA. All rights reserved.
                    </Text>

                    <Stack direction="row" spacing={4} mt={{ base: 4, md: 0 }}>
                        <Link href="/about" _hover={{ textDecoration: "underline" }}>
                            About
                        </Link>
                        <Link href="/terms" _hover={{ textDecoration: "underline" }}>
                            Terms
                        </Link>
                        <Link href="/privacy" _hover={{ textDecoration: "underline" }}>
                            Privacy
                        </Link>
                        <Link href="/contact" _hover={{ textDecoration: "underline" }}>
                            Contact
                        </Link>
                    </Stack>

                    <Stack direction="row" spacing={4} mt={{ base: 4, md: 0 }}>
                        <IconButton
                            as="a"
                            href="https://facebook.com"
                            target="_blank"
                            aria-label="Facebook"
                            icon={<FaFacebook />}
                            variant="ghost"
                        />
                        <IconButton
                            as="a"
                            href="https://twitter.com"
                            target="_blank"
                            aria-label="Twitter"
                            icon={<FaTwitter />}
                            variant="ghost"
                        />
                        <IconButton
                            as="a"
                            href="https://instagram.com"
                            target="_blank"
                            aria-label="Instagram"
                            icon={<FaInstagram />}
                            variant="ghost"
                        />
                    </Stack>
                </Flex>
            </Box>
        </Box>
    );
};

export default WebFooter;
